import React from 'react';
import { useTranslation } from 'next-i18next';
import { LOCALE_COMMON_PATHS, Namespaces, SiteLanguage } from 'types/locales';
import styles from './style.module.scss';
import Button, { TERTIARY_THEME } from 'components/control/button';
import { buildClassName } from 'utils/build-class-name';
import Link from 'components/link';
import InfoIconColour from 'components/icon/info-icon-colour';
import { useThemeContext } from 'contexts';

export enum ProviderContentType {
  CREA = 'crea'
}

interface Props {
  className?: string;
  content?: ProviderContentType;
  onDismiss: () => void;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * Please migrate to use the new banner component located in src/components/banner/
 * instead of this legacy ProviderBanner component.
 */
function ProviderBanner({ className, content = ProviderContentType.CREA, onDismiss }: Props) {
  const { t, i18n } = useTranslation(Namespaces.COMMON);
  const { theme } = useThemeContext();
  
  let bannerContent;
  if (content) {
    switch (content) {
      case ProviderContentType.CREA:
        bannerContent = (
          <p>
            {t(LOCALE_COMMON_PATHS.PROVIDER_BANNER_CREA_TERMS_TEXT, {
              defaultValue: 'By using our site, you agree to our',
            })}{' '}
            <Link href={theme.termsOfUse(i18n.language as SiteLanguage)} target="_blank" onClick={onDismiss}>
              {t(LOCALE_COMMON_PATHS.PROVIDER_BANNER_CREA_TERMS_LINK, {
                defaultValue: 'Terms of Use',
              })}
            </Link>
          </p>
        );
        break;
      default:
        break;
    }
  }

  return (bannerContent ?
    <div className={buildClassName(styles.component, className)}>
      <div className={styles.content}>
        <InfoIconColour className={styles.icon} />
        <div>{bannerContent}</div>
      </div>
      <div>
        <Button
          onClick={onDismiss}
          label={t(LOCALE_COMMON_PATHS.PROVIDER_BANNER_DISMISS_BUTTON, {
            defaultValue: 'Dismiss',
          })}
          theme={TERTIARY_THEME}
          className={styles['custom-button-style']}
        />
      </div>
    </div>
    :
    null
  );
}

export { ProviderBanner };